import styles from "../table.module.css";
import { FaChartBar } from "react-icons/fa";
const FooterButtons = ({ setFilterType, filterType }) => {
  const filterOptions = [
    { label: "A-Z", value: "A-Z" },
    { label: <FaChartBar />, value: "Percentage" },
    { label: "Z-A", value: "Z-A" },
  ];
  return (
    <div className={styles.filterTooltipFooter}>
      {filterOptions?.map((option) => (
        <button
          className={`${styles.filterTabButton} ${
            filterType === option?.value && styles.active
          } semi-bold`}
          onClick={() => setFilterType(option?.value)}
        >
          {option?.label}
        </button>
      ))}
    </div>
  );
};

export default FooterButtons;
